import { TextField, type TextFieldProps } from "$components/inputs";
import React from "react";
import { useIntl } from "react-intl";

const TextFieldWrapper = React.forwardRef(
  (
    props: Omit<TextFieldProps, "clearButtonTitle">,
    ref: React.Ref<HTMLTextAreaElement>,
  ) => {
    const { formatMessage } = useIntl();

    return (
      <TextField
        {...props}
        ref={ref}
        clearButtonTitle={formatMessage({
          id: "textField.clear",
          defaultMessage: "Clear",
        })}
      />
    );
  },
);

export default TextFieldWrapper;
